module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Book-cdef4db861d669f41ba14a9c03e05fe6.otf";